<app-header [title]="title" [subtitle]="subtitle"></app-header>
<main class="what-plaster">
  <div class="containero">
    <div class="row">
      <div class="col col-md-9 col-xs-12 right-border-white">
        <iframe  src="https://www.youtube.com/embed/mqCnUVG-wdo" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      <div class="col- col-lg-3 col-xs-12">
        <aside>

          <p>  Wybierz jeden z gotowych projektów lub wgraj zdjęcie swojego domu. Skorzystaj z gotowych palet kolorystycznych lub twórz własne zestawienia z gamy kolorów Knauf. Zaznacz powierzchnie na elewacji, wytnij okna i drzwi, wybierz powierzchnię i pokoloruj ją. Możesz zmienić kolor kilku powierzchni jednocześnie. Nie bój się eksperymentować!</p>
          <p>Program podpowie Ci także wybór rodzaju tynku - szybko stworzysz listę zakupową, z którą możesz się udać prosto do hurtowni.</p>
          <h3>Zapraszamy!</h3>
        </aside>
      </div>
    </div>
  </div>
</main>
<footer>
  <div class="containero">
    <a  href="javascript:void(0)" class="btn btn-primary nav-button-prev" (click)="goBack()">
      <div class="content"  >POWRÓT</div>
    </a>
  </div>
  <a mdbBtn floating="true"  class="waves-light" style="display: none">
  </a>
</footer>

